<template>
    <div class="centerPage">
        <headerPage></headerPage>
        <div class="centerPage-content">
            <el-card class="box-card">
                <div class="content">
                    <div class="master">
                        <el-form style="margin-right:20px" :model="user" :rules="rules" ref="ruleForm"
                            label-width="140px">
                            <el-form-item label="登陆账号" prop="username">
                                <el-input size="mini" disabled v-model="user.username"></el-input>
                            </el-form-item>
                            <el-form-item label="用户名" prop="nickname">
                                <el-input size="mini" v-model="user.nickname"></el-input>
                            </el-form-item>
                            <el-form-item label="邮箱" prop="email">
                                <el-input size="mini" v-model="user.email"></el-input>
                            </el-form-item>
                            <el-form-item label="联系电话" prop="mobile">
                                <el-input size="mini" v-model="user.mobile"></el-input>
                            </el-form-item>
                            <el-form-item label="性别" prop="sex">
                                <el-radio-group v-model="user.sex">
                                    <el-radio :label="1">男</el-radio>
                                    <el-radio :label="2">女</el-radio>
                                    <el-radio :label="0">未知</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="上次登录时间" prop="loginDate">
                                <el-input size="mini" disabled v-model="user.loginDate"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="submit">
                            <el-button type="primary" plain size="mini" @click="submit">保存</el-button>
                        </div>
                    </div>
                    <div class="slave">
                        <div class="img">
                            <el-image
                                style="object-fit: cover;width: 300px; height: 300px;overflow: hidden;border-radius: 50%;"
                                :src="$store.getters.avatar">
                            </el-image>
                        </div>
                        <div class="btns">
                            <div>
                                <el-upload ref="upload" :action="url" :show-file-list="false"
                                    :before-upload="beforeAvatorUpload" :on-success="handleAvatorSuccess"
                                    accept="image/*" :headers="headers" :data="uploadData" name="avatarFile">
                                    <el-button style="margin-top:15px" size="mini"
                                        icon="el-icon-picture-outline-round">修改头像</el-button>
                                </el-upload>
                            </div>
                            <div style="margin-top:15px">
                                <el-button size="mini" icon="el-icon-key" @click="changePassword">修改密码</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </el-card>
        </div>

        <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" width="30%" :before-close="handlePasswordClose">
            <span>请输入{{ user.username }}的旧密码：</span>
            <el-input style="margin-top:10px" show-password v-model="oldPassword" size="mini"
                autocomplete="off"></el-input>
            <span>请输入{{ user.username }}的新密码：</span>
            <el-input style="margin-top:10px" show-password v-model="newPassword" size="mini"
                autocomplete="off"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="handlePasswordClose">取 消</el-button>
                <el-button size="mini" type="primary" @click="passwordSubmit">确 定</el-button>
            </span>
        </el-dialog>
        <bottomPage></bottomPage>
    </div>
</template>

<script>
import { mixin } from "@/minix";
import headerPage from "@/components/header/header"
import bottomPage from "@/components/bottom/bottom"

import { getAccessToken } from "@/utils/auth";

import * as UserApi from '@/api/user'

export default {
    mixins: [mixin],
    components: {
        headerPage,
        bottomPage
    },
    data() {
        var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入联系电话'));
            } else {
                const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
                if (reg.test(value)) {
                    callback();
                } else {
                    return callback(new Error('请输入正确的联系电话'));
                }
            }
        };
        return {
            user: {},
            uploadData: {}, // 👈 空对象或根据后端需要加字段
            rules: {
                nickname: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                ],
                email: [
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, validator: checkPhone, message: '请输入正确的联系电话', trigger: 'blur' },
                ],
            },
            oldPassword: "",
            newPassword: "",
            passwordDialogVisible: false,
            url: process.env.VUE_APP_BASE_API + '/app-api/' + 'system/hdjg/user/update-avatar',
            headers: { Authorization: "Bearer " + getAccessToken() }, // 设置上传的请求头部
        }
    },
    created() {
        this.loadUser();
    },
    methods: {
        async loadUser() {
            const res = await UserApi.getProfileUserInfo(this.$store.getters.userId);
            this.user = res.data;
            this.user.loginDate = this.formatTimestamp(this.user.loginDate);
        },
        formatTimestamp(ms) {
            const date = new Date(ms);
            const Y = date.getFullYear();
            const M = String(date.getMonth() + 1).padStart(2, "0");
            const D = String(date.getDate()).padStart(2, "0");
            const h = String(date.getHours()).padStart(2, "0");
            const m = String(date.getMinutes()).padStart(2, "0");
            const s = String(date.getSeconds()).padStart(2, "0");
            return `${Y}-${M}-${D} ${h}:${m}:${s}`;
        },
        async submit() {
            const res = await UserApi.updateUserProfile(this.user);
            if (res.data) {
                this.$message.success("修改成功!")
            }
        },
        beforeAvatorUpload(file) {
            const isImage = file.type.startsWith('image/');
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isImage) {
                this.$message.error('只能上传图片格式的文件！');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isImage && isLt2M;
        },
        handleAvatorSuccess(response) {
            if (response.code === 0) {
                this.$message.success("头像更新成功！");
                // 触发 Vuex 更新头像（假设 response.data 是新头像 URL）
                this.$store.commit("user/SET_AVATAR", response.data);
                this.avatar = [response.data];
            } else {
                this.$message.error("头像上传失败：" + response.msg);
            }
        },
        changePassword() {
            this.passwordDialogVisible = true;
        },
        handlePasswordClose() {
            this.passwordDialogVisible = false;
        },
        async passwordSubmit() {
            if (this.oldPassword.length < 4 || this.oldPassword.length > 16 || this.newPassword.length < 4 || this.newPassword.length > 16) {
                this.$message.error("密码长度为4-16位!");
                return;
            }
            const res = await UserApi.updateUserPwd(this.oldPassword, this.newPassword);
            if (res.data) {
                this.passwordDialogVisible = false;
                this.$message.success("修改成功!")
            }
        },
    },
}
</script>

<style scoped>
.centerPage {
    width: 100%;
    height: 100%;
    background-image: url('@/assets/image/index/index_back.png');
}

.centerPage-content {
    width: 100%;
    display: flex;
    justify-content: center;
}

.box-card {
    margin-top: 30px;
    margin-bottom: 30px;
    width: 70%;
}

.content {
    width: 100%;
    height: 550px;
    display: flex;
    flex-direction: row;
    font-family: "黑体";
}

.master {
    width: 60%;
    border-right: 1px solid #E5E5E5;
}

.submit {
    width: 100%;
    text-align: center;
}

.slave {
    width: 40%;
}

.img {
    width: 100%;
    height: 75%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.btns {
    width: 100%;
    height: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>